import React, { useMemo } from 'react';
import {
  OrderExportConfigurationContext,
  OrderExportConfigurationContextProps,
  orderExportConfigurationSlice,
} from '../context/OrderExportConfigurationContext';
import { OrderExportConfiguration } from '../types/orderExportConfiguration';
import { useAppDispatch, useAppSelector } from '../ui/pages/store';

interface OrderExportConfigurationProviderProps {
  children: React.ReactNode;
}

export default function OrderExportConfigurationProvider({ children }: OrderExportConfigurationProviderProps) {
  const dispatch = useAppDispatch();
  const items = useAppSelector(state => state.orderExportConfigurations.items);
  const loading = useAppSelector(state => state.orderExportConfigurations.loading);

  const orderExportConfigurations = useMemo(() => {
    return new Map(items.map(item => [item.id, new OrderExportConfiguration(item)]));
  }, [items]);

  const orderExportConfigurationContext: OrderExportConfigurationContextProps = {
    orderExportConfigurations,
    orderExportConfigurationsLoading: loading,
    setOrderExportConfigurations: (orderExportConfigurations: Map<string, OrderExportConfiguration>) =>
      dispatch(orderExportConfigurationSlice.actions.setAll([...orderExportConfigurations.values()])),
  };

  return (
    <OrderExportConfigurationContext.Provider value={orderExportConfigurationContext}>
      {children}
    </OrderExportConfigurationContext.Provider>
  );
}
